import {
  ButtonLink,
  FilterSearchAndSelect,
  PageHeader,
  PaperContent,
  Table,
  getFilterYearOptions,
  useDialog,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { format, parse } from "date-fns"
import { useNavigate } from "react-router-dom"
import { apiRoleConf } from "../api.roleConf"
import type { ApiListExtraLabNewsFlash } from "../model/ApiFormExtraLabNewsFlash"
import { newsFlashStatusesReferential } from "../referentials/newsFlashStatusesReferential"
import {
  type ExtraLabNewsFlashRowApi,
  extraLabNewsFlashListColumns,
} from "./extraLabNewsFlashList.columns"

const yearsOptions = getFilterYearOptions({ nbPreviousYearsToDisplay: 3 })

export const ExtraLabNewsFlashList = () => {
  const dialog = useDialog()

  // Routing
  const navigate = useNavigate()
  const handleDetail = (id: number) => navigate(`${id}`)

  const { endpoint, queryKey } = useRoleConf(apiRoleConf)
  const getBasePathById = (id: number) => `${endpoint}/${id}`

  const extraRowApi: ExtraLabNewsFlashRowApi = {
    getBasePathById,
    handleDetail,
    dialog,
  }

  return (
    <>
      {/* HEADER */}
      <PageHeader title="Flash Info Extranet Laboratoire">
        <ButtonLink variant="contained" to="./create">
          Créer un Flash Info
        </ButtonLink>
      </PageHeader>

      {/* TABLE */}
      <PaperContent>
        <Table<
          ApiListExtraLabNewsFlash,
          ApiListExtraLabNewsFlash,
          ExtraLabNewsFlashRowApi
        >
          queryConfig={{
            queryKey,
            resourceEndpoint: endpoint,
            select: (list) =>
              list?.map(({ publicationDate, ...fields }) => ({
                ...fields,
                publicationDate: formatDate(publicationDate),
              })),
          }}
          FilterSectionElement={
            <>
              <FilterSearchAndSelect
                name="year"
                label="Année"
                options={yearsOptions}
                sorted={false}
              />
              <FilterSearchAndSelect
                name="status"
                label="statut"
                options={newsFlashStatusesReferential}
              />
            </>
          }
          emptyMessage="Aucun flash info"
          columns={extraLabNewsFlashListColumns}
          extraRowApi={extraRowApi}
          onRowClick={(row) => handleDetail(row.id)}
        />
      </PaperContent>
    </>
  )
}

const formatDate = (date: string) =>
  format(parse(date, "yyyy-MM-dd", new Date()), "dd/MM/yyyy")
